import _extends from '@babel/runtime/helpers/extends';
import _jsx from '@babel/runtime/helpers/jsx';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React, { useState, useRef, useEffect } from 'react';
import 'prop-types';
import ProgressIndicatorCircular from '@andes/progress-indicator-circular';
import classnames from 'classnames';
import { global, targetHostnameValidator, sanitizedData } from '@vpp-frontend-components/common';
const _excluded = ["id", "title", "height", "onLoad", "onMessage", "scrolling", "src", "className", "showSpinner", "spinnerClassname", "forceSpinner"];
const namespace = 'ui-pdp-iframe';
const Iframe = _ref => {
  let {
      id = null,
      title = null,
      height = null,
      onLoad = null,
      onMessage = null,
      scrolling = 'auto',
      src,
      className = '',
      showSpinner = true,
      spinnerClassname = null,
      forceSpinner = false
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const [isLoading, setIsLoading] = useState(true);
  const iframeEl = useRef(null);
  useEffect(() => {
    setIsLoading(true);
  }, [src]);
  useEffect(() => {
    function handleMessage(e) {
      const trustedOrigins = targetHostnameValidator({
        target: src,
        currentLocation: e.origin
      });
      if (!trustedOrigins) {
        return;
      }
      if (onMessage && e.data && e.data.type) {
        onMessage(sanitizedData(e.data.type), sanitizedData(e.data), iframeEl.current);
      }
    }
    global.addEventListener('message', handleMessage);
    return () => {
      global.removeEventListener('message', handleMessage);
    };
  }, [src, onMessage]);
  const handleOnLoad = e => {
    if (onLoad) {
      onLoad(e);
    }
    setIsLoading(false);
  };
  const shouldShowSpinner = forceSpinner || showSpinner && isLoading;
  return /*#__PURE__*/React.createElement(React.Fragment, null, shouldShowSpinner && /*#__PURE__*/_jsx(ProgressIndicatorCircular, {
    modifier: "fullscreen",
    size: "large",
    className: spinnerClassname
  }), /*#__PURE__*/React.createElement("iframe", _extends({
    id: id,
    className: classnames(namespace, className, [{
      'ui-pdp-iframe--loading': shouldShowSpinner
    }]),
    onLoad: handleOnLoad,
    title: title,
    src: src,
    frameBorder: "0",
    scrolling: scrolling,
    style: height ? {
      height: `${height}px`
    } : null,
    ref: iframeEl
  }, rest)));
};
const IframeWithMemo = /*#__PURE__*/React.memo(Iframe);
export { IframeWithMemo as Iframe };
